import React from 'react';
import { string, number, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import useStyles from 'hooks/useStyles';
import styles from './Price.scss';

const Price = ({
  originalPrice,
  sellingPrice,
  perMonth,
  hasUnit,
  hasDiscount,
  className,
  hasMultiplePrices,
}) => {
  useStyles(styles);
  const { t } = useTranslation(['purchase']);

  const priceWithMonthString = hasMultiplePrices
    ? 'purchase.pricingDisplay.priceWithMonthMin'
    : 'purchase.pricingDisplay.priceWithMonth';
  const priceWithNoMonthString = hasMultiplePrices
    ? 'purchase.pricingDisplay.priceNoMonthMin'
    : 'purchase.pricingDisplay.priceNoMonth';

  return (
    <div className={cx(styles.price, className)}>
      {sellingPrice &&
        (hasUnit ? (
          <div>
            {t(priceWithMonthString, {
              price: sellingPrice,
              perMonth: perMonth > 1 ? perMonth : '',
            })}
          </div>
        ) : (
          <div>
            {t(priceWithNoMonthString, {
              price: sellingPrice,
            })}
          </div>
        ))}
      {hasDiscount &&
        (hasUnit ? (
          <del className={styles.originalPrice}>
            {t(priceWithMonthString, {
              price: originalPrice,
              perMonth: perMonth > 1 ? perMonth : '',
            })}
          </del>
        ) : (
          <del className={styles.originalPrice}>
            {t(priceWithNoMonthString, {
              price: originalPrice,
            })}
          </del>
        ))}
    </div>
  );
};

Price.propTypes = {
  perMonth: number,
  originalPrice: string,
  sellingPrice: string,
  hasUnit: bool.isRequired,
  hasDiscount: bool.isRequired,
  className: string,
  hasMultiplePrices: bool,
};

Price.defaultProps = {
  perMonth: null,
  originalPrice: null,
  sellingPrice: null,
  className: null,
  hasMultiplePrices: false,
};

export default Price;
